<!-- ═══════════════ HERO SECTION ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pt-8 pb-10 md:pt-10 md:pb-8 relative z-10">

  <!-- Full-Section Ambient Dot Particles -->
  <div class="particle hero-p1"></div>
  <div class="particle hero-p2"></div>
  <div class="particle hero-p3"></div>
  <div class="particle hero-p4"></div>
  <div class="particle hero-p5"></div>
  <div class="particle hero-p6"></div>
  <div class="particle hero-p7"></div>
  <div class="particle hero-p8"></div>
  <div class="particle hero-p9"></div>
  <div class="particle hero-p10"></div>
  <div class="particle hero-p11"></div>
  <div class="particle hero-p12"></div>
  <div class="particle hero-p13"></div>
  <div class="particle hero-p14"></div>
  <div class="particle hero-p15"></div>
  <div class="particle hero-p16"></div>
  <div class="particle hero-p17"></div>
  <div class="particle hero-p18"></div>
  <div class="particle hero-p19"></div>
  <div class="particle hero-p20"></div>
  <div class="particle hero-p21"></div>
  <div class="particle hero-p22"></div>
  <div class="particle hero-p23"></div>
  <div class="particle hero-p24"></div>

  <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">

    <!-- Left: High-Contrast Display Typography -->
    <div class="lg:col-span-7 flex flex-col gap-6 relative z-10">
      <h1
        class="font-display font-black text-[28px] sm:text-[42px] md:text-[48px] lg:text-[56px] leading-[1.05] tracking-tighter text-white uppercase">
        <span class="block">{{ state.homeCms().hero.title }}</span>
        <span class="block text-gold text-glow-gold relative w-fit">{{ state.homeCms().hero.highlight }}
          <svg
            class="absolute -left-2 -bottom-2 w-[110%] h-[14px] text-gold drop-shadow-[0_0_8px_rgba(245,183,59,0.8)] pointer-events-none"
            viewBox="0 0 200 20" fill="none" preserveAspectRatio="none">
            <!-- Main brush stroke -->
            <path d="M2,14 Q60,4 140,12 T198,8" stroke="currentColor" stroke-width="4" stroke-linecap="round"
              pathLength="100" style="stroke-dasharray: 100; stroke-dashoffset: 100;" class="animate-brush-draw-1" />
            <!-- Sketchy secondary stroke -->
            <path d="M10,16 Q80,10 150,15 T190,13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              pathLength="100" style="stroke-dasharray: 100; stroke-dashoffset: 100;" class="animate-brush-draw-2" />
          </svg>
        </span>
      </h1>

      <p class="text-text-muted text-[14.5px] leading-relaxed max-w-[480px]">
        {{ state.homeCms().hero.description }}
      </p>

      <div class="flex items-center gap-3 mt-2">
        <button (click)="state.selectTab('swap')"
          class="btn-gold px-7 py-3 rounded-lg text-[13px] font-bold tracking-wide">
          Trade Now
        </button>
        <button (click)="state.selectTab('liquidity')"
          class="btn-outline border-gold/30 text-gold hover:bg-gold/5 px-7 py-3 rounded-lg text-[13px] font-bold tracking-wide">
          Explore Pools
        </button>
      </div>
    </div>

    <!-- Right: Glassmorphic Swap Widget -->
    <div class="lg:col-span-5 relative py-6 flex items-center justify-center">
      <!-- The Glassmorphic Swap Card sits on top (z-10) -->
      <div
        class="card p-6 relative overflow-hidden rounded-[20px] bg-[#0c0c0c]/80 border border-white/[0.08] shadow-[0_12px_45px_rgba(0,0,0,0.8)] z-10 w-full">

        <!-- Swap Header -->
        <div class="flex items-center justify-between mb-5">
          <div>
            <h2 class="font-display font-extrabold text-[19px] text-white tracking-wide">Swap</h2>
            <p class="text-text-dim text-[11px] mt-0.5">Trade tokens in an instant</p>
          </div>
          <div class="relative">
            <button (click)="state.showSlippageDropdown.set(!state.showSlippageDropdown())"
              class="p-2 text-text-dim hover:text-white transition-colors" title="Slippage Settings">
              <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.43l-1.003.828c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.43l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
              </svg>
            </button>

            <!-- Slippage Tolerance Settings -->
            @if (state.showSlippageDropdown()) {
            <div
              class="absolute right-0 mt-2.5 w-44 bg-[#0a0a0a]/95 backdrop-blur-2xl border border-border-primary rounded-xl p-3.5 shadow-2xl z-20 animate-fade-in">
              <span class="text-[10px] text-text-dim font-bold block mb-2 uppercase tracking-wider">Slippage
                Tolerance</span>
              <div class="grid grid-cols-3 gap-1.5">
                @for (val of [0.1, 0.5, 1.0]; track val) {
                <button (click)="state.setSlippage(val)"
                  class="text-[11px] font-bold py-2 border rounded-lg text-white transition-all duration-200"
                  [class.border-gold]="state.slippageTolerance() === val"
                  [class.bg-gold/15]="state.slippageTolerance() === val"
                  [class.border-border-primary]="state.slippageTolerance() !== val"
                  [class.bg-white/[0.02]]="state.slippageTolerance() !== val"
                  [class.hover:bg-white/[0.04]]="state.slippageTolerance() !== val">{{ val }}%</button>
                }
              </div>
            </div>
            }
          </div>
        </div>

        <!-- INPUT FORM: FROM -->
        <div
          class="bg-[#050505] border border-white/[0.08] focus-within:border-gold/25 rounded-xl p-4 transition-all duration-200">
          <div class="flex items-center justify-between text-[11px] font-semibold text-text-dim mb-1.5">
            <span>From</span>
          </div>
          <div class="flex items-center justify-between gap-3">
            <input type="text" placeholder="0" [value]="state.fromAmount() ? state.fromAmount() : ''"
              (input)="state.onFromAmountChange($event)" class="swap-input text-[24px] font-bold" />
            <button (click)="state.openTokenModal('from')"
              class="border border-gold/30 bg-[#0f0f0f] rounded-xl px-3.5 py-1.5 flex items-center gap-2 hover:bg-white/[0.03] transition-colors shrink-0">
              <span
                class="w-5.5 h-5.5 rounded-full flex items-center justify-center text-[10px] font-bold text-white shadow-md bg-[#F3BA2F] overflow-hidden"
                [style.background]="state.fromToken().symbol === 'BNB' ? '#F3BA2F' : state.fromToken().color">
                @if (state.fromToken().logoUrl) {
                <img [src]="state.fromToken().logoUrl" class="w-full h-full object-cover" />
                } @else if (state.fromToken().symbol === 'BNB') {
                <svg class="w-3.5 h-3.5 text-black" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M16.624 13.9202L12 18.5442L7.376 13.9202L12 9.29624L16.624 13.9202ZM12 4.07227L16.624 8.69624L18.936 6.38428L12 0.54425L5.064 6.38428L7.376 8.69624L12 4.07227ZM24 12.0002L18.064 6.06427L15.752 8.37628L20.376 13.0002L15.752 17.6243L18.064 19.9363L24 12.0002ZM0 12.0002L5.936 17.9363L8.248 15.6243L3.624 13.0002L8.248 8.37628L5.936 6.06427L0 12.0002ZM12 19.9282L7.376 15.3042L5.064 17.6163L12 23.4563L18.936 17.6163L16.624 15.3042L12 19.9282Z" />
                </svg>
                } @else {
                {{ state.fromToken().symbol.charAt(0) }}
                }
              </span>
              <span class="text-[13.5px] font-extrabold text-white tracking-wide">{{ state.fromToken().symbol }}</span>
              <svg class="w-3 h-3 text-text-muted" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
          </div>
          <div class="text-right text-[10px] text-text-dim mt-2 leading-none">
            Balance: {{ state.isWalletConnected() ? state.getFormattedBalance(state.fromToken().address) : '--' }}
          </div>
        </div>

        <!-- FLIP ASSET DIRECTION SWITCH -->
        <div class="flex justify-center -my-3.5 relative z-10">
          <button (click)="state.swapTokensDirection()" class="swap-direction-btn">
            <svg class="w-4 h-4 text-gold" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m0 0 7.5-7.5M12 19.5 4.5 12" />
            </svg>
          </button>
        </div>

        <!-- INPUT FORM: TO -->
        <div
          class="bg-[#050505] border border-white/[0.08] focus-within:border-gold/25 rounded-xl p-4 transition-all duration-200 mt-1">
          <div class="flex items-center justify-between text-[11px] font-semibold text-text-dim mb-1.5">
            <span>To (estimated)</span>
          </div>
          <div class="flex items-center justify-between gap-3">
            <input type="text" placeholder="0" [value]="state.toAmount() ? state.toAmount() : ''"
              (input)="state.onToAmountChange($event)" class="swap-input text-[24px] font-bold" />
            @if (state.toToken(); as toToken) {
            <button (click)="state.openTokenModal('to')"
              class="border border-gold/30 bg-[#0f0f0f] rounded-xl px-3.5 py-1.5 flex items-center gap-2 hover:bg-white/[0.03] transition-colors shrink-0">
              <span
                class="w-5.5 h-5.5 rounded-full flex items-center justify-center text-[10px] font-bold text-white shadow-md bg-gold overflow-hidden"
                [style.background]="toToken.color">
                @if (toToken.logoUrl) {
                <img [src]="toToken.logoUrl" class="w-full h-full object-cover" />
                } @else {
                {{ toToken.symbol.charAt(0) }}
                }
              </span>
              <span class="text-[13.5px] font-extrabold text-white tracking-wide">{{ toToken.symbol }}</span>
              <svg class="w-3 h-3 text-text-muted" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            } @else {
            <button (click)="state.openTokenModal('to')"
              class="border border-gold/30 bg-[#0f0f0f] rounded-xl px-3.5 py-1.5 flex items-center gap-2 hover:bg-white/[0.03] transition-colors shrink-0">
              <span class="text-[13.5px] font-extrabold text-text-muted tracking-wide">Select a token</span>
              <svg class="w-3 h-3 text-text-muted" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
              </svg>
            </button>
            }
          </div>
          <div class="text-right text-[10px] text-text-dim mt-2 leading-none">
            Balance: {{ state.toToken() && state.isWalletConnected() ? state.getFormattedBalance(state.toToken()?.address) : '--' }}
          </div>
        </div>

        <!-- SLIPPAGE INFO & VALUES -->
        <div class="flex items-center justify-between mt-4 px-1 text-xs font-semibold text-text-muted">
          <span class="text-text-dim text-[11px]">Slippage Tolerance</span>
          <span (click)="state.showSlippageDropdown.set(!state.showSlippageDropdown())"
            class="slippage-link font-bold text-white flex items-center gap-1.5">
            {{ state.slippageTolerance() }}%
            <svg class="w-3.5 h-3.5 text-text-dim" fill="none" viewBox="0 0 24 24" stroke-width="2.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
          </span>
        </div>

        <!-- CONNECT OR SWAP MAIN TRIGGER -->
        <div class="mt-5">
          <button (click)="state.goToSwapWithParams()"
            class="btn-gold w-full py-3.5 rounded-lg text-[13.5px] font-extrabold tracking-widest uppercase shadow-[0_0_20px_rgba(245,183,59,0.2)]">
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
</section>